<template>
  <div>
    <my-header></my-header>

    <div class="section-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="content-box">
        <h2>Rush {{rushId}}</h2>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'Rush',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    rushId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    menuItems() {
      const thisObj = this;

      return [
        {
          title: 'Info',
          route: {name: 'rush_info', params: {rushId: this.rushId}},
          isActive() {
            const path = thisObj.$route.path;
            return path.endsWith('info') || path.endsWith('edit');
          },
        },
        {
          title: 'Races',
          route: {name: 'rush_races', params: {rushId: this.rushId}},
        },
        {
          title: 'Statistics',
          route: {name: 'rush_stat', params: {rushId: this.rushId}},
        },
      ];
    },
  },
};
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  width: 600px;
  padding-top: 1em;
}
</style>
